import React, { useState } from "react";

function Contact() {
  const [formData, setFormData] = useState({ 
    name: "", 
    email: "", 
    phone: "",
    message: "" 
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = "Ad və soyad daxil edilməlidir";
    } else if (formData.name.trim().length < 3) {
      newErrors.name = "Ad və soyad minimum 3 simvol olmalıdır";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) {
      newErrors.email = "Email daxil edilməlidir";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Düzgün email daxil edin";
    }

    const phoneRegex = /^(\+994|0)(50|51|55|70|77|99)[0-9]{7}$/;
    if (formData.phone && !phoneRegex.test(formData.phone.replace(/\s/g, ''))) {
      newErrors.phone = "Düzgün telefon nömrəsi daxil edin (məs: +994501234567)";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Mesaj daxil edilməlidir";
    } else if (formData.message.trim().length < 10) {
      newErrors.message = "Mesaj minimum 10 simvol olmalıdır";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);

    setTimeout(() => {
      console.log("Form məlumatı:", formData);
      setSubmitted(true);
      setLoading(false);
      
      setTimeout(() => {
        setFormData({ name: "", email: "", phone: "", message: "" });
        setSubmitted(false);
      }, 3000);
    }, 1500);
  };

  return (
    <div className="elaqe_page_wrapper">
      <div className="elaqe_container_main">
        <div className="elaqe_hero_section">
          <div className="elaqe_hero_content">
            <h1 className="elaqe_main_title">Bizimlə Əlaqə</h1>
            <p className="elaqe_main_description">
              Sualınız, təklifiniz və ya hər hansı müraciətiniz üçün bizimlə əlaqə saxlayın. 
              Komandamız ən qısa zamanda sizə cavab verəcək.
            </p>
          </div>
        </div>

        <div className="elaqe_content_grid">
          {/* elaqe Information */}
          <div className="elaqe_info_card">
            <div className="elaqe_info_header">
              <h2 className="elaqe_info_title">Əlaqə Məlumatları</h2>
              <div className="elaqe_header_line"></div>
            </div>

            <div className="elaqe_info_items">
              <div className="elaqe_info_item">
                <div className="elaqe_info_icon elaqe_phone_icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                </div>
                <div className="elaqe_info_content">
                  <h3>Telefon</h3>
                  <a href="tel:+994501112233">+994 50 111 22 33</a>
                  <p>Bazar ertəsi - Cümə, 09:00 - 18:00</p>
                </div>
              </div>

              <div className="elaqe_info_item">
                <div className="elaqe_info_icon elaqe_email_icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                </div>
                <div className="elaqe_info_content">
                  <h3>Email</h3>
                  <a href="mailto:support@herrac.com">support@herrac.com</a>
                  <p>24 saat ərzində cavab veririk</p>
                </div>
              </div>

              <div className="elaqe_info_item">
                <div className="elaqe_info_icon elaqe_location_icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                </div>
                <div className="elaqe_info_content">
                  <h3>Ünvan</h3>
                  <p>Bakı şəhəri, Nizami küçəsi 123</p>
                  <p>Ofis 45, 4-cü mərtəbə</p>
                </div>
              </div>

              <div className="elaqe_info_item">
                <div className="elaqe_info_icon elaqe_time_icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12 6 12 12 16 14"/>
                  </svg>
                </div>
                <div className="elaqe_info_content">
                  <h3>İş Saatları</h3>
                  <p>Bazar ertəsi - Cümə: 09:00 - 18:00</p>
                  <p>Şənbə: 10:00 - 14:00</p>
                </div>
              </div>
            </div>

            <div className="elaqe_social_links">
              <h3>Bizi sosial şəbəkələrdə izləyin</h3>
              <div className="elaqe_social_icons">
                <a href="#" className="elaqe_social_icon elaqe_facebook" aria-label="Facebook">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a href="#" className="elaqe_social_icon elaqe_instagram" aria-label="Instagram">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
                <a href="#" className="elaqe_social_icon elaqe_linkedin" aria-label="LinkedIn">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
                <a href="#" className="elaqe_social_icon elaqe_whatsapp" aria-label="WhatsApp">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* elaqe Form */}
          <div className="elaqe_form_card">
            <div className="elaqe_form_header">
              <h2>Mesaj Göndərin</h2>
              <p>Aşağıdakı formu doldurun və bizimlə əlaqə saxlayın</p>
            </div>

            <form className="elaqe_form_main" onSubmit={handleSubmit}>
              <div className="elaqe_form_group">
                <label htmlFor="name" className="elaqe_form_label">
                  Ad və Soyad <span className="elaqe_required">*</span>
                </label>
                <input 
                  type="text" 
                  id="name"
                  name="name" 
                  value={formData.name} 
                  onChange={handleChange}
                  className={`elaqe_form_input ${errors.name ? "elaqe_input_error" : ""}`}
                  placeholder="Adınız və soyadınız"
                  disabled={loading}
                />
                {errors.name && <span className="elaqe_error_message">{errors.name}</span>}
              </div>

              <div className="elaqe_form_row">
                <div className="elaqe_form_group">
                  <label htmlFor="email" className="elaqe_form_label">
                    Email <span className="elaqe_required">*</span>
                  </label>
                  <input 
                    type="email" 
                    id="email"
                    name="email" 
                    value={formData.email} 
                    onChange={handleChange}
                    className={`elaqe_form_input ${errors.email ? "elaqe_input_error" : ""}`}
                    placeholder="email@example.com"
                    disabled={loading}
                  />
                  {errors.email && <span className="elaqe_error_message">{errors.email}</span>}
                </div>

                <div className="elaqe_form_group">
                  <label htmlFor="phone" className="elaqe_form_label">Telefon</label>
                  <input 
                    type="tel" 
                    id="phone"
                    name="phone" 
                    value={formData.phone} 
                    onChange={handleChange}
                    className={`elaqe_form_input ${errors.phone ? "elaqe_input_error" : ""}`}
                    placeholder="+994 50 123 45 67"
                    disabled={loading}
                  />
                  {errors.phone && <span className="elaqe_error_message">{errors.phone}</span>}
                </div>
              </div>

              <div className="elaqe_form_group">
                <label htmlFor="message" className="elaqe_form_label">
                  Mesajınız <span className="elaqe_required">*</span>
                </label>
                <textarea 
                  id="message"
                  name="message" 
                  rows="6" 
                  value={formData.message} 
                  onChange={handleChange}
                  className={`elaqe_form_textarea ${errors.message ? "elaqe_input_error" : ""}`}
                  placeholder="Mesajınızı bura yazın..."
                  disabled={loading}
                />
                {errors.message && <span className="elaqe_error_message">{errors.message}</span>}
              </div>

              <button 
                type="submit" 
                className="elaqe_submit_btn"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="elaqe_spinner"></span>
                    Göndərilir...
                  </>
                ) : (
                  <>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <line x1="22" y1="2" x2="11" y2="13"/>
                      <polygon points="22 2 15 22 11 13 2 9 22 2"/>
                    </svg>
                    Göndər
                  </>
                )}
              </button>

              {submitted && (
                <div className="elaqe_success_message">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                    <polyline points="22 4 12 14.01 9 11.01"/>
                  </svg>
                  <p>Mesajınız uğurla göndərildi! Tezliklə sizinlə əlaqə saxlayacağıq.</p>
                </div>
              )}
            </form>
          </div>
        </div>

        {/* Map Section */}
        <div className="elaqe_map_section">
          <h2>Ofisimizin Yeri</h2>
          <div className="elaqe_map_container">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3039.4229648474654!2d49.8441!3d40.3777!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDIyJzM5LjciTiA0OcKwNTAnMzguOCJF!5e0!3m2!1sen!2saz!4v1234567890"
              width="100%" 
              height="400" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy"
              title="Ofis Xəritəsi"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;